import ENDPOINTS from '@/constants/endpoints';
import { get } from '@/lib/api/client';
import type { ReportCategory } from '../types/report';

export const reportService = {
  getPermittedReports: async (moduleId: string): Promise<ReportCategory[]> => {
    return get<ReportCategory[]>(ENDPOINTS.REPORT.PERMITTED, {
      params: { moduleId },
    });
  },
};
